import React from 'react';
import { bookingShape, historyDetailShape } from 'constants/propTypes';
import { FormattedMessage } from 'react-intl';

import { ActionWrapper, HistoryWrapper } from './HistoryDetail.styles';
import HistoryActionCustomer from './HistoryActionCustomer';
import HistoryActionPassenger from './HistoryActionPassenger';
import HistoryActionPayment from './HistoryActionPayment';
import HistoryActionBookingItems from './HistoryActionBookingItems';
import HistoryActionTicket from './HistoryActionTicket';
import HistoryNoteContent from './HistoryNoteContent';
import { isPassageValidation } from './HistoryDetails.utils';

const getTranslationKey = (action, detail) => {
  if (action === 'validations_created') {
    return isPassageValidation(detail.revisionContents, detail.data.tickets, action)
      ? 'history.validations_created'
      : 'history.validations_created_validated';
  }
  if (action === 'validations_cancelled') {
    return isPassageValidation(detail.revisionContents, detail.data.tickets, action)
      ? 'history.validations_cancelled'
      : 'history.validations_cancelled_voided';
  }
  return `history.${action}`;
};

const HistoryActionContent = ({ booking, detail }) => {
  const actionItems = {
    customer_updated: HistoryActionCustomer,
    passengers_created: HistoryActionPassenger,
    passengers_updated: HistoryActionPassenger,
    payments_created: HistoryActionPayment,
    payments_updated: HistoryActionPayment,
    items_cancelled: HistoryActionBookingItems,
    items_created: HistoryActionBookingItems,
    items_updated: HistoryActionBookingItems,
    validations_created: HistoryActionTicket,
    validations_cancelled: HistoryActionTicket
  };

  const getItemAction = (action) => {
    const Item = actionItems[action];

    return Item && <Item booking={booking} detail={detail} action={action} />;
  };

  return (
    <>
      {detail?.data?.content && <HistoryNoteContent content={detail.data.content} />}
      <HistoryWrapper>
        {detail.actions.map((action) => {
          const item = getItemAction(action);

          return (
            item && (
              <ActionWrapper key={action}>
                <FormattedMessage id={getTranslationKey(action, detail)} />
                {item}
              </ActionWrapper>
            )
          );
        })}
      </HistoryWrapper>
    </>
  );
};

HistoryActionContent.propTypes = {
  booking: bookingShape,
  detail: historyDetailShape.isRequired
};

export default HistoryActionContent;
